import dotenv from "dotenv";
dotenv.config();
const {
  API_URL,
  API_USER_EMAIL,
  API_USER_PASSWORD
} = process.env;
async function POST({ request }) {
  const url = API_URL;
  await request.json();
  const auth = Buffer.from(`${API_USER_EMAIL}:${API_USER_PASSWORD}`).toString("base64");
  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Authorization": `Basic ${auth}`,
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      "query": "page('photography')",
      "select": {
        "url": true,
        "id": true,
        "title": "page.title",
        "description": "page.description.kirbytext",
        "images": {
          "query": "page.images",
          "select": {
            "url": true,
            "niceSize": true,
            "alt": "file.alt.kirbytext"
          }
        }
      }
    })
  });
  const data = await res.json();
  console.log(data.status);
  throw new Error("@migration task: Migrate this return statement (https://github.com/sveltejs/kit/discussions/5774#discussioncomment-3292701)");
}
export {
  POST
};
